import { createContext, Context } from 'react';

import { IAppEntryContext } from './interfaces';

export const appEntryParamsContext: Context<IAppEntryContext> = createContext(
  {} as IAppEntryContext
);
